import { fabric } from "fabric";

fabric.Object.NUM_FRACTION_DIGITS = 17;

//override toObject of fabric.Pattern
var toFixed = fabric.util.toFixed;
fabric.Pattern.prototype.toObject = function (propertiesToInclude) {
  var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
    source,
    object;
  if (typeof this.source === "function") {
    source = String(this.source);
  } else if (typeof this.source.src === "string") {
    source = this.source.src;
  } else if (typeof this.source === "object" && this.source.toDataURL) {
    source = this.source.src;
    // source = this.source.toDataURL();
  }
  object = {
    type: "pattern",
    source: source,
    // source: this.source.src,
    repeat: this.repeat,
    crossOrigin: this.crossOrigin,
    offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
    offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
    patternTransform: this.patternTransform
      ? this.patternTransform.concat()
      : null,
    src: this.src,
  };
  fabric.util.populateWithProperties(this, object, propertiesToInclude);
  return object;
};

fabric.Rect.prototype.toObject = function (propertiesToInclude) {
  let filters = [];

  let properties = {};

  if (this.filters) {
    this.filters.forEach((filterObj) => {
      if (filterObj && filterObj.hasOwnProperty("toObject")) {
        filters.push(filterObj.toObject());
      } else {
        filters.push(filterObj);
      }
    });
    properties = { ...properties, filters: filters };
  }

  if (this.type === "video") {
    // To avoid recurssion from video.js toObject
    properties = {
      ...properties,
      src: this.get("src"),
      file: this.get("file"),
      container: this.get("container"),
      editable: this.get("editable"),
    };
  }

  let object = fabric.util.object.extend(
    this.callSuper("toObject", propertiesToInclude),
    properties
  );

  return object;
};

fabric.Image.prototype.toObject = function (propertiesToInclude) {
  let filters = [];

  if (this.filters) {
    this.filters.forEach((filterObj) => {
      if (filterObj && filterObj.hasOwnProperty("toObject")) {
        filters.push(filterObj.toObject());
      } else {
        filters.push(filterObj);
      }
    });
  }

  var object = fabric.util.object.extend(
    this.callSuper("toObject", ["cropX", "cropY"].concat(propertiesToInclude)),
    {
      src: this.getSrc(),
      crossOrigin: this.getCrossOrigin(),
      filters: filters,
    }
  );
  if (this.resizeFilter) {
    object.resizeFilter = this.resizeFilter.toObject();
  }
  return object;
};

fabric.Object.prototype.strokeUniform = true;
fabric.Object.prototype.noScaleCache = false;
fabric.textureSize = 4096;

fabric.Group.prototype.toObject = function (
  propertiesToInclude,
  propertiesToExclude
) {
  var _includeDefaultValues = this.includeDefaultValues;
  var objsToObject = this._objects
    .filter(function (obj) {
      return !obj.excludeFromExport;
    })
    .map(function (obj) {
      var originalDefaults = obj.includeDefaultValues;
      obj.includeDefaultValues = _includeDefaultValues;
      var _obj = obj.toObject(propertiesToInclude, propertiesToExclude);
      obj.includeDefaultValues = originalDefaults;
      return _obj;
    });
  var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
  obj.objects = objsToObject;
  return obj;
};

fabric.Group.prototype.toJSON = function (
  propertiesToInclude,
  propertiesToExclude
) {
  return this.toObject(propertiesToInclude, propertiesToExclude);
};

fabric.Gif.fromURL = function (url, callback, giphyOptions) {
  fabric.util.loadImage(
    url,
    function (giphy, isError) {
      callback && callback(new fabric.Gif(giphy, giphyOptions), isError);
    },
    null,
    giphyOptions && giphyOptions.crossOrigin
  );
};

// Note: we are changing check in this line
// filters = filters.filter(function(filter) { return filter && filter.isNeutralState && !filter.isNeutralState(); });
// because fabric not checking filter.isNeutralState method exists or not
fabric.Image.prototype.applyFilters =  function(filters) {
  filters = filters || this.filters || [];
  filters = filters.filter(function(filter) { return filter && filter.isNeutralState && !filter.isNeutralState(); });
  this.set('dirty', true);

  // needs to clear out or WEBGL will not resize correctly
  this.removeTexture(this.cacheKey + '_filtered');

  if (filters.length === 0) {
    this._element = this._originalElement;
    this._filteredEl = null;
    this._filterScalingX = 1;
    this._filterScalingY = 1;
    return this;
  }

  var imgElement = this._originalElement,
    sourceWidth = imgElement.naturalWidth || imgElement.width,
    sourceHeight = imgElement.naturalHeight || imgElement.height;

  if (this._element === this._originalElement) {
    // if the element is the same we need to create a new element
    var canvasEl = fabric.util.createCanvasElement();
    canvasEl.width = sourceWidth;
    canvasEl.height = sourceHeight;
    this._element = canvasEl;
    this._filteredEl = canvasEl;
  }
  else {
    // clear the existing element to get new filter data
    // also dereference the eventual resized _element
    this._element = this._filteredEl;
    this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
    // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
    this._lastScaleX = 1;
    this._lastScaleY = 1;
  }
  if (!fabric.filterBackend) {
    fabric.filterBackend = fabric.initFilterBackend();
  }
  fabric.filterBackend.applyFilters(
    filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
  if (this._originalElement.width !== this._element.width ||
    this._originalElement.height !== this._element.height) {
    this._filterScalingX = this._element.width / this._originalElement.width;
    this._filterScalingY = this._element.height / this._originalElement.height;
  }
  return this;
}

// Note: we are preventing continue of this function with adding this part of code !path.shouldCache
// because fabric not checking path.shouldCache method exists or not
fabric.Object.prototype._drawClipPath = function(ctx) {
  var path = this.clipPath;
  if (!path || !path.shouldCache) { return; }

  // needed to setup a couple of variables
  // path canvas gets overridden with this one.
  // TODO find a better solution?
  path.canvas = this.canvas;
  path.shouldCache();
  path._transformDone = true;
  path.renderCache({ forClipping: true });
  this.drawClipPathOnCache(ctx);
}
